import { z } from '@repo/schema'
import { GetLoadTagSchema } from '@repo/schema/tag'

type Tag = z.infer<typeof GetLoadTagSchema>
export const reduceTags = (tags: Tag[]) =>
  tags?.reduce<{ admin: Tag[]; all: Tag[]; system: Tag[] }>(
    (acc, tag) => {
      if (tag.tag_type?.is_system) {
        acc.system.push(tag)
      } else {
        acc.admin.push(tag)
      }
      acc.all.push(tag)
      return acc
    },
    { admin: [], all: [], system: [] },
  )
